<template>
  <div class="management-agent-box">
    <div class="content-box">
      <!-- 搜索栏 -->
      <div class="content_title data_screen">
        <div class="data_screen_line">
          <span class="title">管理员</span>
          <el-input
            v-model="search"
            placeholder="搜索姓名，手机号"
            style="width: 400px"
            size="small"
            suffix-icon="el-icon-search"
            clearable
            @change="pageChange(1)"
          />
          <el-button
            class="search_btn"
            size="small"
            @click="pageChange(1)"
            >查询</el-button>
            
          <el-button
            type="primary"
            class="btn_add btn"
            size="small"
            @click="clickAdd"
            >添加管理员</el-button
          >
        </div>
      </div>
      <!-- 具体内容 -->
      <div class="content">
        <div class="content_auto">
          <!-- 表格 -->
          <el-table :data="table_data" style="width: 100%">
            <el-table-column prop="phone" label="手机/账号"></el-table-column>
            <el-table-column
              prop="name"
              label="姓名"
              align="center"
            ></el-table-column>
            <el-table-column prop="type" label="类型" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.type != 1">普通管理员</span>
                <span v-if="scope.row.type == 1" style="color: red">超级管理员</span>
              </template>
            </el-table-column>
            <el-table-column prop="email" label="邮件"></el-table-column>

            <el-table-column prop="disabledStatus" label="状态" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.disabledStatus == 1">正常</span>
                <span v-if="scope.row.disabledStatus != 1" style="color: red">禁用</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="createTime"
              label="创建时间"
              align="center"
            ></el-table-column>
            <el-table-column label="操作" width="320" align="center">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  v-if="scope.row.disabledStatus != 1"
                  style="color: #00cb9f"
                  @click="clickStatus(scope.row)"
                  >启用</el-button
                >

                <el-button
                  type="text"
                  v-if="scope.row.disabledStatus == 1"
                  style="color: red"
                  @click="clickStatus(scope.row)"
                  >禁用</el-button
                >&nbsp;
                <el-button
                  type="text"
                  style="color: #00cb9f"
                  @click="clickUpdate(scope.row)"
                  >编辑</el-button
                >&nbsp;
                <el-button
                  type="text"
                  style="color: #00cb9f"
                  @click="clickUpdatePassword(scope.row)"
                  >修改密码</el-button
                >&nbsp;
                <el-button
                  type="text"
                  style="color: red"
                  @click="clickDelete(scope.row)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <!-- 表格结束 -->
          <!-- 分页 -->
          <div class="page">
            <el-pagination
              background
              layout="total, pager, next"
              :total="page.total"
              :page-size="page.size"
              @current-change="pageChange"
            ></el-pagination>
          </div>
        </div>
      </div>

      <!-- 添加成员弹出框 -->
      <el-dialog
        :title="dialogType == 1 ? '添加管理员' : '编辑管理员'"
        :rules="rules"
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        width="540px"
      >
        <div class="dialog_context">
          <el-form :model="form" :rules="rules" ref="addForm">
            <el-form-item
              label="手机/账号"
              :label-width="dialogWidth"
              prop="phone"
            >
              <el-input v-model="form.phone" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="姓名" :label-width="dialogWidth" prop="name">
              <el-input v-model="form.name" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="邮件" :label-width="dialogWidth" prop="email">
              <template>
                <el-input v-model="form.email" autocomplete="off"></el-input>
              </template>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="dialogVisible = false"
            >取 消</el-button
          >
          <el-button
            size="small"
            type="primary"
            @click="addSubmit('addForm')"
            class="btn"
            >确 定</el-button
          >
        </span>
      </el-dialog>
      <!-- 删除弹出框 -->
      <el-dialog
        :title="delTitle"
        :rules="rules"
        :visible.sync="delDialogVisible"
        :close-on-click-modal="false"
        width="540px"
      >
        <div class="dialog_context">
          <el-form :model="form" :rules="rules" ref="delForm">
            <el-form-item label="管理员" :label-width="dialogWidth">
              <el-input
                v-model="form.name"
                autocomplete="off"
                :disabled="true"
              ></el-input>
            </el-form-item>
            <el-form-item label="手机号" :label-width="dialogWidth">
              <el-input
                v-model="form.phone"
                autocomplete="off"
                :disabled="true"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="delDialogVisible = false"
            >取 消</el-button
          >
          <el-button
            size="small"
            type="primary"
            @click="submitUpdate('delForm')"
            class="btn"
            >确 定</el-button
          >
        </span>
      </el-dialog>
      <!-- 修改密码弹出框 -->
      <el-dialog
        title="修改密码"
        :rules="rules"
        :visible.sync="updatePasswordDialogVisible"
        :close-on-click-modal="false"
        width="540px"
      >
        <div class="dialog_context">
          <el-form :model="form" :rules="rules" ref="delForm">
            <el-form-item label="管理员" :label-width="dialogWidth">
              <el-input
                v-model="form.name"
                autocomplete="off"
                :disabled="true"
              ></el-input>
            </el-form-item>
            <el-form-item label="手机号" :label-width="dialogWidth">
              <el-input
                v-model="form.phone"
                autocomplete="off"
                :disabled="true"
              ></el-input>
            </el-form-item>
            <el-form-item label="密码" :label-width="dialogWidth" prop="password">
              <el-input
                v-model="form.password"
                autocomplete="off"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="updatePasswordDialogVisible = false"
            >取 消</el-button
          >
          <el-button
            size="small"
            type="primary"
            @click="submitUpdate('delForm')"
            class="btn"
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    // 校验手机号
    var checkPhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("手机号不能为空"));
      }
      if (!/^1[3456789]\d{9}$/.test(value)) {
        return callback(new Error("手机号不正确"));
      }
      callback();
    };

    // 校验手机号
    var checkEmail = (rule, value, callback) => {
      if (!value) {
        callback();
      }

      if(String(value).toLowerCase().match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(($[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}$)|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)){
        callback();
      }

      return callback(new Error("邮件格式不正确"));
    };

    return {
      // 弹出框显示
      dialogVisible: false,
      dialogWidth: "100px",
      // 弹出窗类型：1 添加
      dialogType: 1,
      // 添加成员的数据
      form: {
        id: null,
        phone: null,
        name: null,
        email: "1",
        password: null,
        disabledStatus: 0
      },
      // 删除弹出框
      delDialogVisible: false,
      delTitle: "删除管理员",
      // 校验规则
      rules: {
        phone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { validator: checkPhone, trigger: "blur" },
        ],
        name: [
          { required: true, message: "请输入姓名", trigger: "blur" },
          {
            min: 2,
            max: 30,
            message: "长度在 2 到 30 个字符",
            trigger: "blur",
          },
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          {
            min: 6,
            max: 30,
            message: "长度在 6 到 20 个字符",
            trigger: "blur",
          },
        ],
        email: [
          { required: false, message: "", trigger: "blur" },
          { validator: checkEmail, trigger: "blur" },
        ],
      },
      // 搜索
      search: null,
      // 分页属性
      page: {
        currPage: 1,
        size: 10,
        total: 3,
      },
      // 表格数据
      table_data: [],
      user: null,
      // 修改密码弹出窗
      updatePasswordDialogVisible:false,
      // return 结束
    };
  },
  updated() {},
  created() {
    this.user = JSON.parse(sessionStorage.getItem("user"));
    this.query();
  },
  methods: {
    // 分页改变
    pageChange(res) {
      //console.log("分页", res);
      this.page.currPage = res;
      this.query();
    },
    // 查询
    query() {
      let that = this;
      const url = "/api/web/admin/queryAdmin";
      that.table_data = [];
      this.$axios
        .post(url, {
          param:{
            name:this.search
          }, 
          page: this.page.currPage,
          size: this.page.size,
        })
        .then((res) => {
          if (res.data.code == 1000) {
            that.table_data = res.data.data.list;
            that.page.total = Number(res.data.data.totalItems);
          } else if (res.data.code == 4030) {
          } else if (res.data.code == 2001) {
            that.$message.error("登录失效，请重新登录");
            that.$router.push({ path: "/login" });
          } else {
            that.$message.info(res.data.message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 点击了详情
    clickInfo(res) {},
    // 点击了状态
    clickStatus(row) {
      this.form.id = row.id;
      this.form.name = row.name;
      this.form.phone = row.phone;
      this.form.disabledStatus = row.disabledStatus;
      this.delTitle = (1 == row.disabledStatus ? "禁用" : "启用") + "管理员";
      this.dialogType = 2;
      this.delDialogVisible = true;
    },
    // 点击删除
    clickDelete(row) {
      this.form.id = row.id;
      this.form.name = row.name;
      this.form.phone = row.phone;
      this.delTitle = "删除管理员";
      this.dialogType = 1;
      this.delDialogVisible = true;
    },
    // 点击了修改密码
    clickUpdatePassword(row) {
      this.form.id = row.id;
      this.form.name = row.name;
      this.form.phone = row.phone;
      this.dialogType = 3;
      this.updatePasswordDialogVisible = true;
    },
    submitUpdate(ref) {
      let that = this;
      this.$refs[ref].validate((valid) => {
        // 校验结果
        if (!valid) {
          // 校验不通过
          return;
        }
        var data = {
          id: that.form.id,
          disabledStatus: null,
        };
        let url = "/api/web/admin/deleteAdmin";
        if (that.dialogType == 2) {
          url = "/api/web/admin/updateDisabledStatus";
          data.disabledStatus = 1 == this.form.disabledStatus ? 0 : 1;
        }else if(that.dialogType == 3){
          url = "/api/web/admin/updateAdminPassword";
          data.password = this.form.password;
        }
        that.$axios
          .post(url, data)
          .then((res) => {
            if (res.data.code == 1000) {
              that.$message.success("操作成功");
              that.page.currPage = 1;
              that.query();
              that.delDialogVisible = false;
              that.updatePasswordDialogVisible = false;
            } else if (res.data.code == 4010) {
              that.$message.error("管理员不存在");
            } else if (res.data.code == 2001) {
              that.$message.error("登录失效，请重新登录");
              that.$router.push({ path: "/login" });
            } else {
              that.$message.info(res.data.message);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      });
    },

    // 点击编辑
    clickUpdate(row) {
      this.dialogType = 2;
      // 初始化添加成员数据
      this.form = {
        id: row.id,
        phone: row.phone,
        name: row.name,
        sex: row.sex + "",
        birthday: row.birthday,
      };
      // 显示
      this.dialogVisible = true;
    },
    // 点击了添加
    clickAdd() {
      this.dialogType = 1;
      // 初始化添加成员数据
      this.form = {
        id: null,
        phone: null,
        name: null,
        sex: "1",
        birthday: null,
      };
      // 显示
      this.dialogVisible = true;
    },
    // 提交
    addSubmit(ref) {
      var that = this;
      // 表单校验
      this.$refs[ref].validate((valid) => {
        // 校验结果
        if (!valid) {
          // 校验不通过
          return;
        }

        if (that.form.birthday && that.form.birthday instanceof Date) {
          that.form.birthday = that.dateFormat(
            "yyyy-MM-dd",
            new Date(that.form.birthday)
          );
        }

        if (that.dialogType == 1) {
          // 添加逻辑处理
          const url = "/api/web/admin/addAdmin";
          that.$axios
            .post(url, {
              phone: that.form.phone,
              name: that.form.name,
              email: that.form.email
            })
            .then((res) => {
              if (res.data.code == 1000) {
                that.$message.success("操作成功");
                that.page.currPage = 1;
                that.dialogVisible = false;
                that.query();
              } else if (res.data.code == 4030) {
                that.table_data = [];
              } else if (res.data.code == 2001) {
                that.$message.error("登录失效，请重新登录");
                that.$router.push({ path: "/login" });
              } else {
                that.$message.info(res.data.message);
              }
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          // 修改逻辑处理
          const url = "/api/web/admin/updateAdmin";
          that.$axios
            .post(url, {
              id: that.form.id,
              phone: that.form.phone,
              name: that.form.name,
              email: that.form.email
            })
            .then((res) => {
              if (res.data.code == 1000) {
                that.$message.success("操作成功");
                that.page.currPage = 1;
                that.dialogVisible = false;
                that.query();
              } else if (res.data.code == 4030) {
                that.table_data = [];
              } else if (res.data.code == 2001) {
                that.$message.error("登录失效，请重新登录");
                that.$router.push({ path: "/login" });
              } else {
                that.$message.info(res.data.message);
              }
            })
            .catch((err) => {
              console.log(err);
            });
        }

        // 处理OK之后要做以下事情
        // 隐藏弹出窗
      });
    },
    // 日期格式化
    dateFormat(fmt, date) {
      let ret;
      const opt = {
        "y+": date.getFullYear().toString(), // 年
        "M+": (date.getMonth() + 1).toString(), // 月
        "d+": date.getDate().toString(), // 日
        "H+": date.getHours().toString(), // 时
        "m+": date.getMinutes().toString(), // 分
        "s+": date.getSeconds().toString(), // 秒
        // 有其他格式化字符需求可以继续添加，必须转化成字符串
      };
      for (let k in opt) {
        ret = new RegExp("(" + k + ")").exec(fmt);
        if (ret) {
          fmt = fmt.replace(
            ret[1],
            ret[1].length == 1 ? opt[k] : opt[k].padStart(ret[1].length, "0")
          );
        }
      }
      return fmt;
    },
    // methods 结束
  },
};
</script>

<style scoped>
/* 外盒子 */
.management-agent-box {
  height: 100%;
  width: 100%;
  padding: 15px;
  background: #f8fafb;
  /* background: red; */
}
/* 内盒子 */
.content-box {
  width: 100%;
  height: 100%;
}
/* 内容盒子 */
.content_title {
  width: 100%;
  background: #ffffff;
  padding-left: 30px;
  padding-right: 30px;
  padding-top: 10px;
  border-radius: 5px;
}

/* 内容盒子 */
.content {
  width: 100%;
  height: calc(100% - 90px);
  /* height: 100%; */
  background: #ffffff;
  padding-left: 30px;
  padding-right: 30px;
  padding-top: 10px;
  padding-bottom: 10px;
  border-radius: 5px;
}
.content_auto {
  height: 100%;
  overflow-y: auto;
}
/* 滚动条样式 */
.content_auto::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 6px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
}
.content_auto::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #00cb9f;
}
.content_auto::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 5px rgba(167, 163, 163, 0.2);
  border-radius: 10px;
  background: #ededed;
}

/* 搜索栏 */
.data_screen {
  height: 90px;
  margin-bottom: 15px;
  padding-top: 0px;

  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;
}

/* 搜索栏居中 */
.data_screen_line {
  line-height: 32px;
  width: 100%;
  display: flex;
  justify-content: start;
  align-items: flex-start;
}
/* 标题 */
.title {
  margin-right: 30px;
  font-family: PingFangSC-Semibold;
  font-size: 16px;
  color: #454647;
  letter-spacing: 0;
}
/* 添加按钮 */
.btn_add {
  position: absolute;
  right: 40px;
}
/* 查询按钮 */
.search_btn{
  margin-left: 20px;
}
/* 分页 */
.page {
  /* position:absolute;
  bottom: 50px;
  right: 50px; */
  float: right;
  margin-top: 20px;
}
/* 添加成员弹窗 */
.dialog_context {
  width: 480px;
}
.btn {
  background-color: #00cb9f;
  border: 0;
}
.jur_content {
  margin-bottom: 10px;
  margin-left: 33px;
}
</style>



// WEBPACK FOOTER //
// src/components/views/admin/admin.vue